import { WeekDays } from 'shared/types/week-days';
import { getWeekDays } from 'shared/utils/get-week-days';

import { DayType } from './types';

export const getMonthDayOrdinals = (weekStartsOn?: WeekDays) => {
  return [...getWeekDays(weekStartsOn), ...Object.values(DayType)];
};
